/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.ElevationConfigurationResource = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The ElevationConfigurationResource model module.
   * @module model/ElevationConfigurationResource
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>ElevationConfigurationResource</code>.
   * A class that represents the configuration settings for the Elevation service.
   * @alias module:model/ElevationConfigurationResource
   * @class
   * @param sourceType {String} The source type of the elevation data.
   */
  var exports = function(sourceType) {
    var _this = this;

    _this['sourceType'] = sourceType;











  };

  /**
   * Constructs a <code>ElevationConfigurationResource</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ElevationConfigurationResource} obj Optional instance to populate.
   * @return {module:model/ElevationConfigurationResource} The populated <code>ElevationConfigurationResource</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('sourceType')) {
        obj['sourceType'] = ApiClient.convertToType(data['sourceType'], 'String');
      }
      if (data.hasOwnProperty('srtmDataDirectory')) {
        obj['srtmDataDirectory'] = ApiClient.convertToType(data['srtmDataDirectory'], 'String');
      }
      if (data.hasOwnProperty('ned13DataDirectory')) {
        obj['ned13DataDirectory'] = ApiClient.convertToType(data['ned13DataDirectory'], 'String');
      }
      if (data.hasOwnProperty('s3SecretAccessKey')) {
        obj['s3SecretAccessKey'] = ApiClient.convertToType(data['s3SecretAccessKey'], 'String');
      }
      if (data.hasOwnProperty('s3AccessKeyId')) {
        obj['s3AccessKeyId'] = ApiClient.convertToType(data['s3AccessKeyId'], 'String');
      }
      if (data.hasOwnProperty('s3RegionEndpoint')) {
        obj['s3RegionEndpoint'] = ApiClient.convertToType(data['s3RegionEndpoint'], 'String');
      }
      if (data.hasOwnProperty('s3BucketName')) {
        obj['s3BucketName'] = ApiClient.convertToType(data['s3BucketName'], 'String');
      }
      if (data.hasOwnProperty('s3SrtmDataDirectory')) {
        obj['s3SrtmDataDirectory'] = ApiClient.convertToType(data['s3SrtmDataDirectory'], 'String');
      }
      if (data.hasOwnProperty('s3Ned13DataDirectory')) {
        obj['s3Ned13DataDirectory'] = ApiClient.convertToType(data['s3Ned13DataDirectory'], 'String');
      }
      if (data.hasOwnProperty('isSourceDataZipped')) {
        obj['isSourceDataZipped'] = ApiClient.convertToType(data['isSourceDataZipped'], 'Boolean');
      }
      if (data.hasOwnProperty('ned13ZipDataDirectory')) {
        obj['ned13ZipDataDirectory'] = ApiClient.convertToType(data['ned13ZipDataDirectory'], 'String');
      }
      if (data.hasOwnProperty('srtmZipDataDirectory')) {
        obj['srtmZipDataDirectory'] = ApiClient.convertToType(data['srtmZipDataDirectory'], 'String');
      }
    }
    return obj;
  }

  /**
   * The source type of the elevation data.
   * @member {String} sourceType
   */
  exports.prototype['sourceType'] = undefined;
  /**
   * The path where SRTM (global) elevation data will be cached once requested.
   * @member {String} srtmDataDirectory
   */
  exports.prototype['srtmDataDirectory'] = undefined;
  /**
   * The path where NED13 (North American) elevation data will be cached once requested.
   * @member {String} ned13DataDirectory
   */
  exports.prototype['ned13DataDirectory'] = undefined;
  /**
   * The Secret Access Key for the S3 bucket.
   * @member {String} s3SecretAccessKey
   */
  exports.prototype['s3SecretAccessKey'] = undefined;
  /**
   * The Access Key for the S3 bucket.
   * @member {String} s3AccessKeyId
   */
  exports.prototype['s3AccessKeyId'] = undefined;
  /**
   * The AWS region where the S3 bucket is located.
   * @member {String} s3RegionEndpoint
   */
  exports.prototype['s3RegionEndpoint'] = undefined;
  /**
   * The name of the S3 bucket.
   * @member {String} s3BucketName
   */
  exports.prototype['s3BucketName'] = undefined;
  /**
   * The path where SRTM (global) elevation data will be found on S3 bucket.
   * @member {String} s3SrtmDataDirectory
   */
  exports.prototype['s3SrtmDataDirectory'] = undefined;
  /**
   * The path where NED13 (North American) elevation data will be found on S3 bucket.
   * @member {String} s3Ned13DataDirectory
   */
  exports.prototype['s3Ned13DataDirectory'] = undefined;
  /**
   * The value to indicate if the elevation data source is zipped or not.
   * @member {Boolean} isSourceDataZipped
   */
  exports.prototype['isSourceDataZipped'] = undefined;
  /**
   * The path where NED13 (North American) elevation data will be cached once requested.
   * @member {String} ned13ZipDataDirectory
   */
  exports.prototype['ned13ZipDataDirectory'] = undefined;
  /**
   * The path where SRTM (global) elevation data will be cached once requested.
   * @member {String} srtmZipDataDirectory
   */
  exports.prototype['srtmZipDataDirectory'] = undefined;



  return exports;
}));



